(function (angular) {
  "use strict";

  var PAINT_LOADING_TIMEOUT_DURATION_MS = 400;
  var PAINT_LIST_COLOUR_MATCHER_MINIMUM_PERCENT_MATCH = 0.8;

  angular.module("Toyota.Directives").directive("tyPricingPaintSelector", [
    "CssMediaWatcher",
    "DebugLogger",
    "$timeout",
    function (CssMediaWatcher, DebugLogger, $timeout) {
      function rejectHandler(error) {
        DebugLogger.log("tyPricingPaintSelector", error);
      }

      var controller = [
        "$scope",
        "$element",
        "PricingPageAnalyticsService",
        "$filter",
        "$q",
        "Range",
        "RangeSorting",
        "Animations",
        "PaintListColourMatcher",
        "ColourService",
        "Location",
        "$attrs",
        function (
          $scope,
          $element,
          PricingPageAnalyticsService,
          $filter,
          $q,
          Range,
          RangeSorting,
          Animations,
          PaintListColourMatcher,
          ColourService,
          Location,
          $attrs
        ) {
          var ctl = this;
          var $bodyPaint = $element.find("[data-ty-pricing-paint-selector-body-paint]");
          var $roofPaint = $element.find("[data-ty-pricing-paint-selector-roof-paint]");
          var paintDeferred;
          var firstPass = true;
          var paintChangedPromiseComplete = false;

          function init() {
            $scope.paint = {
              trimId: null,
              bodyPaints: [],
              roofPaints: [],
              roofPaintsDisplay: [],
              selectedBodyPaintID: "",
              selectedBodyPaintName: "",
              selectedBodyPaintNameDisplay: "",
              selectedBodyPaintHex: "",
              savedBodyPaintName: "",
              savedBodyPaintHex: "",
              selectedRoofPaintName: "",
              selectedRoofPaintNameDisplay: "",
              selectedRoofPaintID: "",
              containsRoofPaints: false,
              containedRoofPaints: false,
              loadingTimeout: null,
              source: "body-paint",
              sourceChanged: false,
              eventData: {},
              pricingParams: {
                postcode: null,
                usageType: null,
              },
            };

            Animations.hide($roofPaint);

            $scope.$watch("paint.selectedBodyPaintID", function () {
              $scope.paint.source = "body-paint";
              $scope.paint.sourceChanged = true;
              processNewlySelectedBodyPaint();
            });

            $scope.$watch("paint.selectedRoofPaintID", function () {
              sendPaintChangedEvent();
              $scope.paint.source = $scope.paint.sourceChanged ? $scope.paint.source : "roof-paint";
              $scope.paint.sourceChanged = false;

              if (!$scope.paint.selectedRoofPaintID) {
                return;
              }

              var paint = getBodyPaintByBodyPaintID($scope.paint.selectedBodyPaintID);
              var roofPaint = $filter("arrayFind")(paint.RoofOptions, function (currentRoofPaint) {
                return currentRoofPaint.ID === $scope.paint.selectedRoofPaintID;
              });

              $scope.paint.selectedRoofPaintName = roofPaint.RoofPaintDescription;

              resolvePaintChangedEventDeferred(roofPaint.MaterialCode, roofPaint.ID);
            });

            $scope.$watch("paint.roofPaints", function () {
              $timeout.cancel($scope.paint.loadingTimeout);

              function updateBodyPaintInfo() {
                var paint = getBodyPaintByBodyPaintID($scope.paint.selectedBodyPaintID);
                if (paint) {
                  $scope.paint.selectedBodyPaintName = paint.BodyPaintDescription;
                  $scope.paint.selectedBodyPaintHex = paint.BodyPaintSwatchHex;
                }
              }

              if (!$scope.paint.containsRoofPaints || $scope.paint.source === "variant") {
                updateBodyPaintInfo();
              }

              if (
                (!$scope.paint.containsRoofPaints && !$scope.paint.containedRoofPaints) ||
                $scope.paint.source === "variant"
              ) {
                $scope.paint.roofPaintsDisplay = $scope.paint.roofPaints.slice(0);
                $scope.paint.roofPaintSwatches = roofPaintsToSwatches($scope.paint.roofPaintsDisplay);
                return;
              }

              $scope.paint.loadingTimeout = $timeout(function () {
                if ($scope.paint.containsRoofPaints) {
                  updateBodyPaintInfo();
                }

                $scope.paint.roofPaintsDisplay = $scope.paint.roofPaints.slice(0);
                $scope.paint.roofPaintSwatches = roofPaintsToSwatches($scope.paint.roofPaintsDisplay);
              }, PAINT_LOADING_TIMEOUT_DURATION_MS);
            });

            $scope.$watch("$parent.pricingPage.loading", function (newValue) {
              DebugLogger.log("tyPricingPaintSelector", "paint caught loading change: ", newValue);
              if (newValue === false) {
                hideLoadingOverlay();
              } else {
                $scope.paint.isLoading = true;
              }
            });

            var $bodyPaintDescription = $bodyPaint.find("[data-ty-pricing-paint-selector-option-description]");
            $scope.$watch("paint.selectedBodyPaintName", function () {
              $bodyPaintDescription.fadeOut(function () {
                $timeout(function () {
                  $scope.paint.selectedBodyPaintNameDisplay = $scope.paint.selectedBodyPaintName;
                  $bodyPaintDescription.fadeIn();
                });
              });
            });

            var $roofPaintDescription = $roofPaint.find("[data-ty-pricing-paint-selector-option-description]");
            $scope.$watch("paint.selectedRoofPaintName", function () {
              $roofPaintDescription.fadeOut(function () {
                $timeout(function () {
                  $scope.paint.selectedRoofPaintNameDisplay = $scope.paint.selectedRoofPaintName;
                  $roofPaintDescription.fadeIn();
                });
              });
            });

            $scope.$on("trims-changed", function (event, pricingPageTrimChangedData) {
              $scope.paint.trimIds = pricingPageTrimChangedData.trimIds;
              onTrimsChanged(pricingPageTrimChangedData);
            });

            $scope.$on("GeoPostCode", function (event, postcode) {
              $scope.paint.pricingParams.postcode = postcode;
            });

            $scope.paint.pricingParams.postcode = Location.get().postcode;
          }

          $scope.setBodyPaintID = function (paintID) {
            $scope.paint.selectedBodyPaintID = paintID;
            triggerBodyPaintActiveSelectionAnalyticsEvent(paintID);
          };

          $scope.setRoofPaintID = function (paintID) {
            $scope.paint.selectedRoofPaintID = paintID;
            triggerRoofPaintActiveSelectionAnalyticsEvent(paintID);
          };

          function onTrimsChanged(pricingPageTrimChangedData) {
            DebugLogger.log("tyPricingPaintSelector", "paint onTrimsChanged: ", pricingPageTrimChangedData);
            sendPaintChangedEvent();
            showLoadingOverlay();

            if (pricingPageTrimChangedData.source === "grade") {
              if (pricingPageTrimChangedData.grade.containsRoofPaints) {
                Animations.slideThenFadeIn($roofPaint);
              } else {
                Animations.fadeThenSlideOut($roofPaint);
              }
            }

            $scope.paint.source = pricingPageTrimChangedData.source;
            $scope.paint.sourceChanged = true;
            $scope.paint.containedRoofPaints = $scope.paint.containsRoofPaints;
            $scope.paint.containsRoofPaints = pricingPageTrimChangedData.containsRoofPaints;
            $scope.paint.eventData = pricingPageTrimChangedData;

            resetPaints();

            Range.getPaintsForPaintSelector(
              pricingPageTrimChangedData.variantIds,
              $scope.paint.pricingParams,
              $scope.paint.trimIds
            )
              .then(function (paints) {
                $scope.paint.paints = paints;
                $scope.paint.ordering = paints.map(function (paint) {
                  return paint.BodyPaintDescription;
                });

                updateBodyPaints();
                updateSelectedBodyPaint();
                processNewlySelectedBodyPaint();
              })
              .catch(function (error) {
                $scope.tyPricingPage.handleError(error);
              });
          }

          function resetPaints() {
            $scope.paint.paints = [];
          }

          function updateBodyPaints() {
            $scope.paint.bodyPaints = Range.getBodyPaintsWithRoofOptionsByPaintIdsFromCache(
              $scope.paint.paints.map(function (paint) {
                return paint.ID;
              }),
              null
            ).map(function (paint) {
              return angular.extend(paint, {
                BodyPaintSwatchHexStyle: { "background-color": paint.BodyPaintSwatchHex },
              });
            });
            $scope.paint.bodyPaintSwatches = bodyPaintsToSwatches($scope.paint.bodyPaints);
          }

          function bodyPaintsToSwatches(paints) {
            var nonPlusPaints = paints.filter(
              (paint) =>
                paint.BodyPaintDescription.toLowerCase().indexOf("plus") === -1
            );
            var plusPaints = paints.filter(
              (paint) =>
                paint.BodyPaintDescription.toLowerCase().indexOf("plus") > -1
            );

            plusPaints.forEach(function (plusPaint) {
              var indexOfNonPlusPaint = nonPlusPaints.findIndex(
                (nonPlusPaint) =>
                  nonPlusPaint.BodyPaintSwatchHex ===
                  plusPaint.BodyPaintSwatchHex
              );
              if (indexOfNonPlusPaint > -1 && plusPaint.BodyPaintOrder < plusPaint.RoofPaintOrder) {
                var plusPaintBodyPaintOrder = plusPaint.BodyPaintOrder;
                var plusPaintRoofPaintOrder = plusPaint.RoofPaintOrder;
                plusPaint.BodyPaintOrder = nonPlusPaints[indexOfNonPlusPaint].BodyPaintOrder;
                plusPaint.RoofPaintOrder = nonPlusPaints[indexOfNonPlusPaint].RoofPaintOrder;
                nonPlusPaints[indexOfNonPlusPaint].BodyPaintOrder = plusPaintBodyPaintOrder;
                nonPlusPaints[indexOfNonPlusPaint].RoofPaintOrder = plusPaintRoofPaintOrder;
              }
            });

            var newPaints = [...nonPlusPaints, ...plusPaints];

            var sortedPaints = [...newPaints].sort(function (a, b) {
              if (a.BodyPaintOrder === b.BodyPaintOrder) {
                return a.RoofPaintOrder - b.RoofPaintOrder;
              }
              return a.BodyPaintOrder > b.BodyPaintOrder ? 1 : -1;
            });
            return sortedPaints.map(function (paint) {
              return angular.extend({}, paint, {
                id: paint.BodyPaintId,
                description: paint.BodyPaintDescription,
                hex: paint.BodyPaintSwatchHex,
                image: paint.BodyPaintSwatchImage,
              });
            });
          }

          function roofPaintsToSwatches(paints) {
            var sortedPaints = [...paints].sort(function (a, b) {
              return a.RoofPaintOrder - b.RoofPaintOrder;
            });
            return sortedPaints.map(function (paint) {
              return angular.extend({}, paint, {
                id: paint.ID,
                description: paint.RoofPaintDescription,
                hex: paint.RoofPaintSwatchHex,
                image: paint.RoofPaintSwatchImage,
              });
            });
          }

          $scope.setSelectedTickColour = function (colour) {
            return ColourService.contrastColours(colour) ? "has-light-tick" : "has-dark-tick";
          };

          function processNewlySelectedBodyPaint() {
            if ($scope.paint.selectedBodyPaintID === "") {
              return;
            }

            var bodyPaint = getBodyPaintByBodyPaintID($scope.paint.selectedBodyPaintID);

            PricingPageAnalyticsService.setBodyPaint(bodyPaint.BodyPaintDescription);

            updateRoofPaintOptions(bodyPaint);
          }

          function updateSelectedBodyPaint() {
            var bodyPaint = getSelectedBodyPaint();

            if (bodyPaint) {
              $scope.paint.selectedBodyPaintID = bodyPaint.BodyPaintId;
            }
          }

          function getSelectedBodyPaint() {
            var bodyPaint;

            if (firstPass) {
              if (ctl.initialPaintId) {
                bodyPaint = Range.getBodyPaintsWithRoofOptionsByPaintIdsFromCache([ctl.initialPaintId])[0];
              }
            } else {
              var paintExist = $scope.paint.bodyPaints.findIndex(bodyPaint => bodyPaint.BodyPaintDescription === $scope.paint.selectedBodyPaintName);

              if (paintExist > -1) {

                var closestColourTuple = PaintListColourMatcher({
                  colourTuples: $scope.paint.bodyPaints.map(function (i) {
                    return { description: i.BodyPaintDescription, hex: i.BodyPaintSwatchHex };
                  }),
                }).closestMatch(
                  {
                    description: $scope.paint.savedBodyPaintName || $scope.paint.selectedBodyPaintName,
                    hex: $scope.paint.savedBodyPaintHex || $scope.paint.selectedBodyPaintHex,
                  },
                  PAINT_LIST_COLOUR_MATCHER_MINIMUM_PERCENT_MATCH
                );

                if (closestColourTuple) {
                  return $filter("arrayFind")($scope.paint.bodyPaints, function (currentPaint) {
                    return currentPaint.BodyPaintDescription === closestColourTuple.description;
                  });
                }
              }
            }

            return bodyPaint || $scope.paint.bodyPaints[0];
          }

          function triggerBodyPaintActiveSelectionAnalyticsEvent(bodyPaintID) {
            var bodyPaint = getBodyPaintByBodyPaintID(bodyPaintID);

            PricingPageAnalyticsService.setBodyPaint(bodyPaint.BodyPaintDescription);

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "button - body paint swatch",
              eventLabel: bodyPaint.BodyPaintDescription,
            });
          }

          function triggerRoofPaintActiveSelectionAnalyticsEvent() {
            var paint = getBodyPaintByBodyPaintID($scope.paint.selectedBodyPaintID);
            var roofPaint = $filter("arrayFind")(paint.RoofOptions, function (currentRoofPaint) {
              return currentRoofPaint.ID === $scope.paint.selectedRoofPaintID;
            });

            PricingPageAnalyticsService.setRoofPaint(roofPaint.RoofPaintDescription);

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "button - roof paint swatch",
              eventLabel: roofPaint.RoofPaintDescription,
            });
          }

          function updateSelectedRoofPaint(bodyPaint) {
            var name = getBodyPaintByBodyPaintID($scope.paint.selectedBodyPaintID).BodyPaintDescription;
            var previousSelectedRoofPaintName = $scope.paint.selectedRoofPaintName;
            var roofPaint;

            if (firstPass) {
              firstPass = false;
              roofPaint = $filter("arrayFind")(bodyPaint.RoofOptions, function (currentRoofPaint) {
                return currentRoofPaint.ID === ctl.initialPaintId;
              });
            } else {
              // Since SIR-5945, Update Roof colour swatch to always default to lowest price roof color first, which is to match roof color with body color 
              roofPaint = $filter("arrayFind")(bodyPaint.RoofOptions, function (currentRoofPaint) {
                return currentRoofPaint.RoofPaintDescription === name;
              });
            }

            roofPaint =
              roofPaint ||
              $filter("arrayFind")(bodyPaint.RoofOptions, function (currentRoofPaint) {
                return currentRoofPaint.RoofPaintDescription === previousSelectedRoofPaintName;
              });

            roofPaint = roofPaint || bodyPaint.RoofOptions[0];

            if (roofPaint) {
              $scope.paint.selectedRoofPaintID = roofPaint.ID;
              $scope.paint.pricingParams.usageType = roofPaint.UsageType;
              PricingPageAnalyticsService.setRoofPaint(roofPaint.RoofPaintDescription);
            }
          }

          function getBodyPaintByBodyPaintID(id) {
            return $filter("arrayFind")($scope.paint.bodyPaints, function (currentPaint) {
              return currentPaint.BodyPaintId === id;
            });
          }

          function updateRoofPaintOptions(bodyPaint) {
            $timeout(function () {
              updateSelectedRoofPaint(bodyPaint);
            });

            var fullRoofPaints = bodyPaint.RoofOptions.map(function (roofPaint) {
              return Range.getPaintById(roofPaint.ID);
            });

            $q.all(fullRoofPaints)
              .then(function (roofPaints) {
                var expandedRoofPaints = bodyPaint.RoofOptions.map(function (paint) {
                  var currentPaint = roofPaints.filter(function (rp) {
                    return rp.ID === paint.ID;
                  })[0];

                  var paintHex = currentPaint.RoofPaintSwatchHex !== null ? currentPaint.RoofPaintSwatchHex : "#ffffff";

                  return angular.extend(paint, {
                    RoofPaintSwatchHex: paintHex,
                    RoofPaintSwatchHexStyle: { "background-color": paintHex },
                  });
                });
                $scope.paint.roofPaints = expandedRoofPaints;
              })
              .catch(function (error) {
                $scope.tyPricingPage.handleError(error);
              });
          }

          function resolvePaintChangedEventDeferred(materialCode, paintId) {
            var pricingPagePaintChangedData = {
              grade: $scope.paint.eventData.grade,
              materialCode: materialCode,
              pricingParams: $scope.paint.pricingParams,
              paintId: paintId,
              source: $scope.paint.source,
            };
            paintDeferred.resolve(pricingPagePaintChangedData);
          }

          function sendPaintChangedEvent() {
            if (paintDeferred && !paintDeferred.promise.done) {
              paintDeferred.reject("Pricing paint selector - paint selection changed mid-load");
            }

            paintDeferred = $q.defer();
            var promise = paintDeferred.promise;
            promise.done = false;
            promise
              .then(function () {
                promise.done = true;
                paintChangedPromiseComplete = true;
              })
              .catch(rejectHandler);

            ctl.onPaintChanged(paintDeferred.promise);
          }

          function showLoadingOverlay() {
            paintChangedPromiseComplete = false;
            $scope.paint.isLoading = true;
          }

          function hideLoadingOverlay() {
            $scope.paint.isLoading = !paintChangedPromiseComplete;
          }

          ctl.$onInit = init;
        },
      ];

      return {
        bindToController: {
          initialPaintId: "<initialPaintId",
          onPaintChanged: "<tyPricingPaintSelectorOnPaintChanged",
        },
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyPricingPaintSelectorController",
      };
    },
  ]);
})(window.angular);
